import React, { Component } from "react";
import AddTitleBar from "../../components/titleBar/add_titleBar";
import InsertBookingRequest from "./insertBookingRequest";
import EditInsertShipment from "../../components/createShipmentComponent/editInsertShipment";
import ReadAxios from "../../components/axiosComponent/read";
import { connect } from "react-redux";
import {
  discardShipmentDispatcher,
  createShipmentDispatcher,
} from "../../redux/actions/shipmentAction";
import { successAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import moment from "moment"
import { FEATURES, DATE_FORMATS } from '../../utils/constant'

class CreateBookingRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicleTypeMaster: [],
      shipment: [],
      routeName: "",
      routeCode: "",
      mode: "",
    };
  }

  componentDidMount() {
    if (this.props.location.pathname == "/edit-booking-request") {
      if (this.props.location.state.status == 'In Progress' || this.props.location.state.status == 'Completed' || this.props.location.state.status == 'Cancelled')
        this.setState({ mode: "view" });
      else
        this.setState({ mode: "edit" });

      if (this.props.location.state && this.props.location.state.booking_id) {
        allAxiosCommonTA({
          url: "/bookings/" + this.props.location.state.booking_id + "/booking",
          method: "get",
        })
          .then((response) => {
            if (response.data.data) {
              let bookingObject = response.data.data;
              let deliveryBooking = [];
              let iterateOver = response.data.data.booking_deliveries;
              //let container_size, container_type, container_type_id;

              let DO_no, DO_validity_date;

              for (let index = 0; index < iterateOver.length; index++) {
                let tempData = {};
                const element = iterateOver[index];
                //container_size = element.container_size;
                //container_type = element.container_type;
                //container_type_id = element.container_type_id;

                DO_no = element.DO_no;
                if (element?.DO_validity_date)
                  DO_validity_date = moment(element.DO_validity_date, DATE_FORMATS.YYYYMMDD_HHMM);

                tempData.requested_pickup_date = moment(element?.requested_pickup_date, DATE_FORMATS.YYYYMMDD_HHMM);
                tempData.requested_delivery_date = moment(element?.requested_delivery_date, DATE_FORMATS.YYYYMMDD_HHMM);

                tempData.billing_party_id = element?.billing_party_id;
                tempData.billing_party_placeholder = element?.billing_party_name;

                tempData.billing_party_branch_id = element?.billing_party_branch_id;
                tempData.billing_party_branch_placeholder = element?.billing_party_branch_name;

                tempData.consignor_code = element?.consignor_code ? element?.consignor_code : "";
                tempData.consignor_placeholder = element?.consignor?.consignor_name ? element?.consignor.consignor_name : "";
                tempData.consignorRaw = element?.consignor ? element?.consignor : "";

                tempData.consignee_code = element?.consignee_code ? element?.consignee_code : "";
                tempData.consignee_placeholder = element?.consignee?.consignee_name ? element?.consignee.consignee_name : "";
                tempData.consigneeRaw = element?.consignee ? element?.consignee : "";

                tempData.pickup_area = element?.pickup_area ? element?.pickup_area : "";
                tempData.drop_area = element?.drop_area ? element?.drop_area : "";
                tempData.sales_person_id = element?.sales_person_id ? element?.sales_person_id : "";

                tempData.shipping_line_id = element?.shipping_line_id ? element?.shipping_line_id : null;
                tempData.shipping_line_placeholder = element?.shipping_line_name ? element?.shipping_line_name : "";

                tempData.booking_delivery_id = element?.booking_delivery_id ? element?.booking_delivery_id : "";

                tempData.CHA_id = element?.CHA_id ? element?.CHA_id : null;
                tempData.cha_placeholder = element?.CHA_name ? element?.CHA_name : "";

                tempData.yard_id = element?.yard_id ? element?.yard_id : null;
                tempData.yard_placeholder = element?.yard_name ? element?.yard_name : "";

                tempData.booking_products = element?.booking_products ? element?.booking_products : "";
                tempData.service_type_id = element?.service_type_id ? element.service_type_id : "";

                let bookingInvoice = [];

                for (let indexj = 0; indexj < element?.booking_invoices.length; indexj++) {
                  const elementInvoice = element?.booking_invoices[indexj];
                  elementInvoice.BoE_date = moment(elementInvoice.BoE_date, DATE_FORMATS.YYYYMMDD_HHMM);
                  bookingInvoice.push(elementInvoice)
                }
                tempData.booking_invoices = bookingInvoice;

                deliveryBooking.push(tempData)
              }


              bookingObject.DO_no = DO_no;
              bookingObject.DO_validity_date = DO_validity_date;

              bookingObject.total_number_of_containers = response.data.data.no_of_vehicles;
              bookingObject.booking_containers = response.data.data.booking_containers;


              //bookingObject.container_size = container_size;
              //bookingObject.container_type = container_type;
              //bookingObject.container_type_id = container_type_id;
              bookingObject.deliveryBooking = deliveryBooking;

              this.setState({ shipment: bookingObject });
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    } else {
      this.setState({ mode: "create" });
      this.props.discardShipment();
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/shipment");
    // this.props.history.go();
  };

  render() {
    const { t } = this.props;
    // const { routeCode, routeName} = this.state;
    return (
      <React.Fragment>
        <AddTitleBar
          Title={
            this.props.location.pathname == "/edit-booking-request"
              ? FEATURES.bookingRequestIndentLinkName ? "Indents" : FEATURES.bookingRequestOrdersLinkNameAndShipment ? "Orders" : "Bookings"
              : FEATURES.bookingRequestIndentLinkName ? "Indents" : FEATURES.bookingRequestOrdersLinkNameAndShipment ? "Orders" : "Bookings"
          }
          LinkName="/booking-request"
        />
        <div className="m-2">
          {/* <EditInsertShipment
              mode={this.props.location.pathname == "/edit-booking-request" ? "edit" : "create"}
              vehicleTypeMaster={this.state.vehicleTypeMaster}
              onFormSubmit={this.onFormSubmit}
              bookingRequestObj={this.props.location.state}
            />
          ) : ( */}
          <InsertBookingRequest
            vehicleTypeMaster={this.state.vehicleTypeMaster}
            onFormSubmit={this.onFormSubmit}
            bookingRequestObj={this.state.shipment}
            mode={this.state.mode}
          // routeCodes={this.state.routeCode}
          // routeNames={this.state.routeName !="" ? this.state.routeName : ""}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    discardShipment: () => dispatch(discardShipmentDispatcher()),
    createShipment: (shipment) =>
      dispatch(createShipmentDispatcher(shipment, false)),
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
  };
};
export default connect(
  null,
  mapDispatchToProps
)(translate("shipment")(CreateBookingRequest));
